export default "__VITE_ASSET__cf288e07__"